"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var calcAge_1 = require("./calcAge");
var calcBuyerAge_1 = require("./calcBuyerAge");
function buyer(state) {
    for (var _i = 0, _a = state.paxe; _i < _a.length; _i++) {
        var pax = _a[_i];
        if (pax.isBuyer) {
            return pax;
        }
    }
    return null;
}
exports.buyer = buyer;
function other(state) {
    for (var _i = 0, _a = state.paxe; _i < _a.length; _i++) {
        var pax = _a[_i];
        if (pax.isBuyer) {
            return lodash_1.without(state.paxe, pax);
        }
    }
    return null;
}
exports.other = other;
function all(state) {
    return state.paxe;
}
exports.all = all;
function erpConfirm(state) {
    var erpConfirm = function (index) {
        return all(state)[index] ? all(state)[index].erpConfirm.value : null;
    };
    return erpConfirm;
}
exports.erpConfirm = erpConfirm;
function erpError(state) {
    var erpError = function (index) {
        var erpConfirm = all(state)[index].erpConfirm;
        var erpInfos = all(state)[index].erpInfos;
        if (erpConfirm.touched &&
            erpInfos[0].erpId !== null &&
            erpInfos[0].erpId !== '' &&
            (erpConfirm.value === null || erpConfirm.value === '')) {
            return true;
        }
        return false;
    };
    return erpError;
}
exports.erpError = erpError;
function erpInfo(state) {
    var erpInfo = function (index) {
        return all(state)[index] ? all(state)[index].erpInfo : null;
    };
    return erpInfo;
}
exports.erpInfo = erpInfo;
function erpInfos(state) {
    var erpInfos = function (index) {
        return all(state)[index] ? all(state)[index].erpInfos : null;
    };
    return erpInfos;
}
exports.erpInfos = erpInfos;
function groupForIndex(state) {
    return function (paxIndex) {
        var pax = state.paxe[paxIndex];
        if (!pax || !pax.birthday)
            return;
        var age = calcAge_1.calcAge(pax.birthday.value, state.departureDate);
        if (age > 24)
            return 'A';
        if (age > 15)
            return 'J';
        if (age > 1)
            return 'C';
    };
}
exports.groupForIndex = groupForIndex;
function groupsArray(state) {
    return state.paxe.map(function (_, index) { return groupForIndex(state)(index); });
}
exports.groupsArray = groupsArray;
function groups(state) {
    var ageGroup = {
        A: 0,
        J: 0,
        C: 0,
    };
    groupsArray(state).filter(function (groupElement) { return !!groupElement; } // remove null and undefined elements
    ).forEach(function (groupElement) { return ageGroup[groupElement]++; });
    return ageGroup;
}
exports.groups = groups;
function railGroups(state) {
    var ageGroup = {
        A: 0,
        C: 0,
    };
    for (var _i = 0, _a = state.paxe; _i < _a.length; _i++) {
        var pax = _a[_i];
        var age = calcAge_1.calcAge(pax.birthday.value, state.departureDate);
        if (age > 14) {
            ageGroup.A++;
        }
        else if (age > 1) {
            ageGroup.C++;
        }
    }
    return ageGroup;
}
exports.railGroups = railGroups;
function ages(state) {
    for (var _i = 0, _a = state.paxe; _i < _a.length; _i++) {
        var pax = _a[_i];
        if (pax.birthday.value === undefined ||
            pax.birthday.value === '' ||
            Number.isNaN(calcAge_1.calcAge(pax.birthday.value, state.departureDate)) ||
            calcAge_1.calcAge(pax.birthday.value, state.departureDate) < 2 ||
            calcAge_1.calcAge(pax.birthday.value, state.departureDate) > 99) {
            return false;
        }
    }
    return true;
}
exports.ages = ages;
function ageValues(state) {
    var ages = [];
    for (var _i = 0, _a = state.paxe; _i < _a.length; _i++) {
        var pax = _a[_i];
        ages.push(calcAge_1.calcAge(pax.birthday.value, state.departureDate));
    }
    return ages;
}
exports.ageValues = ageValues;
function buyerAgeValues(state) {
    var ages = [];
    for (var _i = 0, _a = state.paxe; _i < _a.length; _i++) {
        var pax = _a[_i];
        ages.push(calcBuyerAge_1.calcBuyerAge(pax.birthday.value));
    }
    return ages;
}
exports.buyerAgeValues = buyerAgeValues;
function validations(state) {
    return state.formValidations;
}
exports.validations = validations;
function valid(state) {
    return state.allFieldsValid;
}
exports.valid = valid;
function cruiseDate(state) {
    return state.departureDate;
}
exports.cruiseDate = cruiseDate;
function transportationType(state) {
    return state.transportationType;
}
exports.transportationType = transportationType;
function checkPaxChildAge(state) {
    return state.checkPaxChildAge;
}
exports.checkPaxChildAge = checkPaxChildAge;
// export everything compliant to the vuex specification for getters
exports.default = {
    buyer: buyer,
    other: other,
    all: all,
    erpConfirm: erpConfirm,
    erpError: erpError,
    erpInfo: erpInfo,
    erpInfos: erpInfos,
    groupForIndex: groupForIndex,
    groups: groups,
    groupsArray: groupsArray,
    railGroups: railGroups,
    ages: ages,
    validations: validations,
    valid: valid,
    cruiseDate: cruiseDate,
    ageValues: ageValues,
    buyerAgeValues: buyerAgeValues,
    transportationType: transportationType,
    checkPaxChildAge: checkPaxChildAge,
};
//# sourceMappingURL=getters.js.map